export enum FilterType {
    Date = 'date',
    Enum = 'enum',
    Float = 'float',
    Int = 'int',
    Text = 'text'
}
